import {
	useGetAllUsersQuery,
	useGetUserConnectionLogsQuery,
} from '@/features/users/gql/_gen_/user.gql';

export const useUsersList = () => {
	const { data, loading } = useGetAllUsersQuery();
	return {
		usersList: data?.getAllUsers ?? [],
		isLoading: loading,
	};
};

export const useUserConnectionLogs = (okta_id: string) => {
	const { data, loading } = useGetUserConnectionLogsQuery({
		variables: { okta_id: okta_id },
	});

	return {
		userLogs: data?.getUserConnectionLogs,
		isLoading: loading,
	};
};
